import { useEffect, useRef, useState } from "react";
import DataHandlerHelper from "../../helpers/DataHandler.helper";
import { useNavigate } from "react-router-dom";
import clientsApi from "../../api/client/client";
import paymentApi from "../../api/payment/payment";
import trainingTypeApi from "../../api/trainingType/trainingType";
import { ui } from "../../helpers/ui";

const InitPaymentLogic = () => {
  const navigate = useNavigate();
  const [trainingsTypes, setTrainingsTypes] = useState<any[]>([]);
  const trainingTypeRef = useRef<any>();
  const toLocalDateTime = (d: Date) => {
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };
  const [data, setData] = useState<any>({
    price: 0,
    client: "",
    trainingType: "",
    quantity: 1,
    date: toLocalDateTime(new Date()),
  });
  const [clients, setClients] = useState<any[]>([]);
  const [selectedClients, setSelectedClients] = useState<any[]>([]);

  const loadTrainingsTypes = () => {
    trainingTypeApi
      .getTrainingTypes()
      .then((response) => {
        if (response.status === 200) {
          setTrainingsTypes(response.data);
          if (response.data.length > 0) {
            setData((prev: any) => ({
              ...prev,
              trainingType: String(response.data[0].id),
            }));
          }
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const loadClients = () => {
    clientsApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setClients(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onSave = async () => {
    if (!trainingTypeRef.current?.value) {
      ui.alert("Izaberite tip treninga");
      return;
    }
    if (selectedClients.length === 0) {
      ui.alert("Izaberite bar jednog klijenta");
      return;
    }
    if (data.price === "" || data.price == null || +data.price < 0) {
      ui.alert("Unesite ispravnu cenu");
      return;
    }
    const selectedTypeId = +trainingTypeRef.current.value;
    const selectedType = trainingsTypes.find((t) => t.id === selectedTypeId);
    const typeQuantity = selectedType?.quantity ?? 1;

    const confirmed = await ui.confirm("Sigurno želite da sačuvate ovu uplatu?");
    if (!confirmed) return;
    paymentApi
      .savePayment({
        price: +data.price,
        selectedClients: selectedClients,
        trainingTypeId: selectedTypeId,
        quantity: typeQuantity === 1 ? +data.quantity : 1,
        date: data.date ? new Date(data.date).toISOString() : undefined,
      })
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          ui.toast("Uplata sačuvana", "success");
          navigate("/home");
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onChange = (event: any) => {
    setData(DataHandlerHelper.handleInputChange(event, { ...data }));
  };

  const addClient = (client: any) => {
    // Zaštita od duplog klika: bez mutacije state niza i bez duplikata
    if (selectedClients.some((c: any) => c.id === client.id)) return;
    setClients(clients.filter((c: any) => c.id !== client.id));
    setSelectedClients([...selectedClients, client]);
    setData({ ...data, client: "" });
  };

  const removeSelectedClient = (client: any) => {
    if (!selectedClients.some((c: any) => c.id === client.id)) return;
    setSelectedClients(selectedClients.filter((c: any) => c.id !== client.id));
    setClients([...clients, client]);
  };

  useEffect(() => {
    loadTrainingsTypes();
    loadClients();
  }, []);

  return {
    selectedClients,
    clients,
    data,
    trainingTypeRef,
    trainingsTypes,
    onSave,
    onChange,
    addClient,
    removeSelectedClient,
  };
};

export default InitPaymentLogic;
